import { render } from "./EditChefquartier.vue?vue&type=template&id=b59fd714&ts=true"
import script from "./EditChefquartier.vue?vue&type=script&lang=ts"
export * from "./EditChefquartier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__